<div class="container" style="padding-top: 20px;">
  <form [formGroup]="requisitionForm">
    <!-- Keep the header outside scrollable area -->
    <div class="requisition-header">
      <h1 class="requisition-title">Training Requisition Form</h1>
      <div class="action-buttons">
        <button type="button" mat-stroked-button color="warn" (click)="cancelRequisition()">Cancel</button>
        &nbsp;
        <button type="button" mat-stroked-button (click)="saveAsDraft()">Save as Draft</button>
        &nbsp;
        <button type="button" mat-flat-button color="primary" (click)="submitRequisition()">Submit Requisition</button>
      </div>
      <!-- <span class="status-badge" [class.status-draft]="requisitionForm.get('requisition.status')?.value === 'Draft'"
        [class.status-approved]="requisitionForm.get('requisition.status')?.value === 'Approved'">
        {{ requisitionForm.get('requisition.status')?.value }}
      </span> -->
    </div>

    <!-- Wrap all form sections in scrollable content -->
    <div class="scrollable-content">
      <!-- Document Info Section -->
      <div class="form-section" #reqSection>
        <h2 class="section-title" (click)="toggleSection(reqSection)">Requisition</h2>
        <div class="section-content" formGroupName="requisition">
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Document Number</mat-label>
              <input type="text" id="docNo" matInput formControlName="docNo" placeholder="REQ-0001">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Document Date</mat-label>
              <input type="date" id="docDate" matInput formControlName="docDate">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Status</mat-label>
              <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
              <select id="status" matNativeControl formControlName="status">
                <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
              </select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Customer Details Section -->
      <div class="form-section" #customerSection>
        <h2 class="section-title" (click)="toggleSection(customerSection)">Customer Details</h2>
        <div class="section-content" formGroupName="customerDetails">
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Customer Name</mat-label>
              <!-- <input type="text" id="customer" matInput formControlName="customer"
                placeholder="Customer name"> -->
              <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
              <select id="customer" matNativeControl formControlName="customer" (change)="onCustomerChange($event)">
                <option *ngFor="let customer of customers" [value]="customer.id">{{ customer.name }}</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Customer Type</mat-label>
              <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
              <select id="customerType" matNativeControl formControlName="customerType">
                <option *ngFor="let type of customerTypes" [value]="type">{{ type }}</option>
              </select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Contact Person</mat-label>
              <input type="text" id="contactPerson" matInput formControlName="contactPerson"
                placeholder="Contact person name">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Contact Number</mat-label>
              <input type="tel" id="contactNo" matInput formControlName="contactNo"
                placeholder="Contact number">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Email ID</mat-label>
              <input type="email" id="emailId" matInput formControlName="emailId"
                placeholder="Email address">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Billing Details Section -->
      <div class="form-section" #billingSection>
        <h2 class="section-title" (click)="toggleSection(billingSection)">Billing Details</h2>
        <div class="section-content" formGroupName="billingDetails">
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Billing Address</mat-label>
              <textarea id="billingAddress" matInput formControlName="billingAddress"
                placeholder="Full billing address"></textarea>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>GST Number</mat-label>
              <input type="text" id="gstNo" matInput formControlName="gstNo" placeholder="GST number">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Payment Terms</mat-label>
              <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
              <select id="paymentTerms" matNativeControl formControlName="paymentTerms">
                <option *ngFor="let term of paymentTermsOptions" [value]="term">{{ term }}</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Estimated Amount</mat-label>
              <input type="number" id="estimateAmount" matInput formControlName="estimateAmount"
                placeholder="0.00">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Training Schedules Section -->
      <div class="form-section" #schedulesSection>
        <h2 class="section-title" (click)="toggleSection(schedulesSection)">Training Schedules</h2>
        <div class="section-content">
          <!-- Tab Navigation -->
          <div class="schedule-tabs">
            <div class="tab-header">
              <button type="button" class="tab-button" *ngFor="let schedule of schedules.controls; let i = index"
                [class.active]="activeTabIndex === i" (click)="setActiveTab(i)">
                {{ schedule.get('title')?.value || 'Training Schedule ' + (i + 1) }}
              </button>
              <button type="button" mat-stroked-button color="primary" (click)="addSchedule()"
                title="Add new schedule">
                +
              </button>
              <!-- Optional: Add remove button for current tab -->
              <button type="button" mat-stroked-button color="warn" *ngIf="schedules.length > 1"
                (click)="removeCurrentSchedule()" title="Remove current schedule">
                ×
              </button>
            </div>
          </div>

          <!-- Tab Content Container -->
          <div formArrayName="trainingSchedules" class="tab-content-container">
            <!-- Loop through all schedules but show only the active one -->
            <div *ngFor="let schedule of schedules.controls; let i = index" class="schedule-item tab-panel"
              [class.active]="activeTabIndex === i" [formGroupName]="i">

              <!-- Basic Information -->
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Title</mat-label>
                  <input type="text" [id]="'title-' + i" matInput formControlName="title"
                    placeholder="Session title">
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Start Date</mat-label>
                  <input type="date" [id]="'startDate-' + i" matInput formControlName="startDate">
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>End Date</mat-label>
                  <input type="date" [id]="'endDate-' + i" matInput formControlName="endDate">
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Start Time</mat-label>
                  <input type="time" [id]="'startTime-' + i" matInput formControlName="startTime">
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>End Time</mat-label>
                  <input type="time" [id]="'endTime-' + i" matInput formControlName="endTime">
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Off Dates</mat-label>
                  <input type="text" [id]="'offDates-' + i" matInput formControlName="offDates"
                    placeholder="Select dates when training is off">
                </mat-form-field>
                <!-- <div class="form-group full-width">
                  <button class="open-session-btn" (click)="openClassSession()">
                    Create Class Sessions
                  </button>

                  <app-class-session [classId]="sessionParams.classId" [startDate]="sessionParams.startDate"
                    [endDate]="sessionParams.endDate" [startTime]="sessionParams.startTime"
                    [endTime]="sessionParams.endTime" [isVisible]="sessionParams.isVisible">
                  </app-class-session>
                </div> -->
              </div>

              <!-- <div class="form-row">
                <div class="form-group">
                  <label class="form-label" [for]="'trainingType-' + i">Training Type</label>
                  <select [id]="'trainingType-' + i" class="form-control" formControlName="trainingType">
                    <option *ngFor="let type of trainingTypeOptions" [value]="type">{{ type }}</option>
                  </select>
                </div>
              </div> -->
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Course</mat-label>
                  <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
                  <select [id]="'courseId-' + i" matNativeControl formControlName="courseId">
                    <option value="">Select Course</option>
                    <option *ngFor="let course of courseOptions" [value]="course.id">{{ course.name }}</option>
                  </select>
                </mat-form-field>
              </div>
              <!-- Participants Section -->
              <div class="form-row">
                <div>
                  <mat-form-field appearance="outline" style="width:100%">
                    <mat-label>Participants</mat-label>
                    <input type="text" [id]="'participants-' + i" matInput #participantsInput
                      placeholder="Enter participants' emails and press Enter"
                      (keydown.enter)="addParticipant(i, participantsInput); $event.preventDefault()">
                  </mat-form-field>

                  <div class="participants-list">
                    <div class="participant-chip" *ngFor="let participant of getParticipantsArray(i)">
                      {{ participant }} <span class="chip-remove"
                        (click)="removeParticipantChip(i, participant)">×</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Trainers Section -->
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Trainers</mat-label>
                  <!-- <input type="text" [id]="'trainers-' + i" matInput #trainersInput
                    placeholder="Enter trainers' emails and press Enter"
                    (keydown.enter)="addTrainer(i, trainersInput); $event.preventDefault()">
                  <div class="participants-list">
                    <div class="participant-chip" *ngFor="let trainer of getTrainersArray(i)">
                      {{ trainer }} <span class="chip-remove" (click)="removeTrainerChip(i, trainer)">×</span>
                    </div>
                  </div> -->
                  <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
                  <select id="trainer" matNativeControl formControlName="trainers">
                    <option *ngFor="let trainer of trainers" [value]="trainer.id">{{ trainer.name }}</option>
                  </select>
                </mat-form-field>
              </div>
              <!-- Resource Type Selection - Only show when Training Type is 'Instructor-led' -->
              <div class="form-row" *ngIf="schedule.get('courseId')?.value == '-1'">
                <div class="full-width">
                  <label class="form-label">Resource Type</label>
                  <div class="resource-type-panels">
                    <div class="resource-panel" *ngFor="let resourceType of resourceTypes"
                      [class.selected]="getSelectedResourceType(i) === resourceType.value"
                      (click)="selectResourceType(i, resourceType.value)">
                      <img width="80" height="80"
                        [src]="'../../../../assets/images/resources/resource/' + resourceType.value +'.svg'">
                      <div class="panel-label">{{ resourceType.label }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dynamic Resource Type Controls - Only show when Training Type is 'Instructor-led' -->
              <div *ngIf="getSelectedResourceType(i) && schedule.get('courseId')?.value == '-1'"
                class="resource-controls-section">

                <!-- VM Controls -->
                <div *ngIf="getSelectedResourceType(i) === 'vm'" [formGroup]="getVMControls(i)"
                  class="resource-controls">
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Virtual Machine Template</mat-label>
                      <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
                      <select [id]="'vmTemplate-' + i" matNativeControl formControlName="vmTemplate">
                        <option *ngFor="let resource of resourceTemplatesByType['vm']" [value]="resource.id">
                          {{ resource.name }}
                        </option>
                      </select>
                    </mat-form-field>
                    <div>
                      <label>&nbsp;</label>
                      <button title="Add New VM Template" type="button" mat-stroked-button color="primary"
                        (click)="createNewVMTemplate()">+</button>
                    </div>
                  </div>
                </div>

                <!-- Cloud DB Controls -->
                <div *ngIf="getSelectedResourceType(i) === 'db'" [formGroup]="getCloudDBControls(i)"
                  class="resource-controls">
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Database Type</mat-label>
                      <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
                      <select [id]="'dbType-' + i" matNativeControl formControlName="dbType">
                        <option *ngFor="let type of resourceTemplatesByType['db']" [value]="type.id">{{ type.name }}
                        </option>
                      </select>
                    </mat-form-field>
                    <div>
                      <label>&nbsp;</label>
                      <button title="Add New CloudDB" type="button" mat-stroked-button color="primary"
                        (click)="createNewVMTemplate()">+</button>
                    </div>
                  </div>
                </div>

                <!-- App Service Controls -->
                <div *ngIf="getSelectedResourceType(i) === 'app'" [formGroup]="getAppServiceControls(i)"
                  class="resource-controls">
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Service Plan</mat-label>
                      <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
                      <select [id]="'servicePlan-' + i" matNativeControl formControlName="servicePlan">
                        <option *ngFor="let plan of resourceTemplatesByType['app']" [value]="plan.id">{{ plan.name }}
                        </option>
                      </select>
                    </mat-form-field>
                    <div>
                      <label>&nbsp;</label>
                      <button title="Add New App Service" type="button" mat-stroked-button color="primary"
                        (click)="createNewVMTemplate()">+</button>
                    </div>
                  </div>
                </div>

                <!-- User Account Controls -->
                <div *ngIf="getSelectedResourceType(i) === 'acc'" [formGroup]="getUserAccountControls(i)"
                  class="resource-controls">
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Account Type</mat-label>
                      <!-- TODO E-19: review — native select inside mat-form-field; consider mat-select for full Material styling -->
                      <select [id]="'accountType-' + i" matNativeControl formControlName="accountType">
                        <option *ngFor="let type of resourceTemplatesByType['acc']" [value]="type.id">{{ type.name }}
                        </option>
                      </select>
                    </mat-form-field>
                    <div>
                      <label>&nbsp;</label>
                      <button title="Add New User Account" type="button"
                        mat-stroked-button color="primary">+</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- spacing: previously mb-3 -->
              <div style="margin-bottom: 1rem;">
                <h6 class="form-label">Resource Deletion Policy</h6>
                <div style="display:flex; width:100%; margin-bottom: 0.5rem;">
                  <button type="button" style="flex:1; padding: 0.25rem;"
                    [ngClass]="pluginData.removalOption === 'immediate' ? 'btn-active-primary' : 'btn-inactive-primary'"
                    mat-stroked-button
                    [color]="pluginData.removalOption === 'immediate' ? 'primary' : undefined"
                    (click)="setRemovalOption('immediate')">
                    Immediate
                  </button>
                  <button type="button" style="flex:1; padding: 0.25rem;"
                    [ngClass]="pluginData.removalOption === 'scheduled' ? 'btn-active-primary' : 'btn-inactive-primary'"
                    mat-stroked-button
                    [color]="pluginData.removalOption === 'scheduled' ? 'primary' : undefined"
                    (click)="setRemovalOption('scheduled')">
                    Scheduled
                  </button>
                  <button type="button" style="flex:1; padding: 0.25rem;"
                    [ngClass]="pluginData.removalOption === 'manual' ? 'btn-active-primary' : 'btn-inactive-primary'"
                    mat-stroked-button
                    [color]="pluginData.removalOption === 'manual' ? 'primary' : undefined"
                    (click)="setRemovalOption('manual')">
                    Manual
                  </button>
                </div>

                <!-- Removal Option Specific Controls -->
                <div [ngSwitch]="pluginData.removalOption">
                  <!-- Immediate -->
                  <div *ngSwitchCase="'immediate'" style="margin-top: 0.5rem;">
                    <div class="alert alert-info" style="padding: 0.5rem; margin-bottom: 0;">
                      <small>Resource will be deleted one(1) hour after training completion, i.e. on {{
                        getDeletionTime() }}</small>
                    </div>
                  </div>

                  <!-- Scheduled -->
                  <div *ngSwitchCase="'scheduled'" style="margin-top: 0.5rem;">
                    <div class="two-col-row">
                      <div>
                        <label class="small fw-semibold">Delete Resource On
                        </label>
                      </div>
                      <div>
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Delete Resource On</mat-label>
                          <input matInput [matDatepicker]="removalDp" [(ngModel)]="pluginData.removalDateTime"
                            [min]="minRemovalDate" (dateChange)="validateRemovalDate()"
                            [ngModelOptions]="{standalone: true}">
                          <mat-datepicker-toggle matSuffix [for]="removalDp"></mat-datepicker-toggle>
                          <mat-datepicker #removalDp></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- Manual -->
                  <div *ngSwitchCase="'manual'" style="margin-top: 0.5rem;">
                    <div class="alert alert-warning" style="padding: 0.5rem; margin-bottom: 0;">
                      <small>Resource will be left running on the cloud and will incur billing.</small>
                      <br>
                      <small>Please consider adding a removal date or select immediate removal.</small>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Additional Information Section -->
      <div class="form-section" #additionalSection>
        <h2 class="section-title" (click)="toggleSection(additionalSection)">Additional Information</h2>
        <div class="section-content" formGroupName="additionalInfo">
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Special Requirements</mat-label>
              <textarea id="specialRequirements" matInput formControlName="specialRequirements"
                placeholder="Any special requirements or instructions"></textarea>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Final Comments</mat-label>
              <textarea id="finalComments" matInput formControlName="finalComments"
                placeholder="Additional comments"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Action Bar -->
      <!-- <div class="action-bar">
        <button type="button" mat-flat-button color="warn" (click)="cancelRequisition()">Cancel</button>
        <button type="button" mat-stroked-button (click)="saveAsDraft()">Save as Draft</button>
        <button type="button" mat-flat-button color="primary" (click)="submitRequisition()">Submit Requisition</button>
      </div> -->
    </div>
  </form>
</div>
